module.exports = __webpack_public_path__ + "wave2.svg?d3c6e05f846429051c1e60a7ccabec73";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wave2.svg
// module id = 85
// module chunks = 0